module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("To Catch a Thief")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "adCardPage",
    attrs: {
      "id": "adp"
    }
  }, [_c('h2', {
    staticClass: "adCardHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Also available from"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "bold1"
  }, [_c('span', [_vm._v("CHRISTINA SKYE")])]), _c('br'), _vm._v("\nand HQN Books")])])]), _c('p', {
    staticClass: "adCardSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Code Name")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Code Name: Bikini")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Code Name: Blondie")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Code Name: Baby")])])])]), _c('p', {
    staticClass: "adCardSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Draycott Abbey")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Draycott Eternal")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Draycott Legacy")])])])]), _c('p', {
    staticClass: "adCardSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("And coming in winter 2009")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Christmas Knight")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a7f3cc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tocatchathief_adp.vue
// module id = 60
// module chunks = 0